// Shares the streamer dashboard's token key (same auth realm). The editor runs
// on a different subdomain, so localStorage is NOT shared — the streamer app
// hands the token off via the URL hash (#at=…), which we capture on load.
//
// 🔴 **맨손으로 `localStorage` 를 만지지 않는다.** 2026-09-28 에 iOS Chrome 에서
//    `localStorage` 가 `null` 이어서 스트리머 앱의 같은 함수가 앱 전체를 크래시시켰다
//    (ENTER-FUN-STREAMER-C). 에디터는 데스크탑 게이트(1024px)가 있어 노출이 작지만,
//    «작다» 는 «없다» 가 아니고 이 파일은 부팅 경로다.
//    근거는 `@repo/ui` 의 `lib/safe-storage.ts` 머리말.
import { safeGet, safeSet } from '@repo/ui';

const ACCESS_TOKEN_KEY = 'dashboard_access_token';

export function getAccessToken(): string | null {
  return safeGet(ACCESS_TOKEN_KEY);
}

/** 🔴 «심었다» 를 돌려준다 — 저장 실패를 「로그인됨」으로 진행하지 않기 위해서다. */
export function setAccessToken(token: string): boolean {
  return safeSet(ACCESS_TOKEN_KEY, token);
}

export function hasToken(): boolean {
  return Boolean(getAccessToken());
}

/**
 * SSO handoff: if the URL hash carries an access token (`#at=<jwt>`), persist it
 * and strip it from the address bar so it isn't bookmarked/logged. Called once
 * at startup before the app reads auth.
 */
export function captureTokenFromHash(): void {
  if (typeof window === 'undefined' || !window.location.hash) return;
  const match = /[#&]at=([^&]+)/.exec(window.location.hash);
  if (!match?.[1]) return;
  setAccessToken(decodeURIComponent(match[1]));
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
}
